function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "arrow-right_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.176.49a.6.6 0 01.848 0L8.11 7.577a.6.6 0 010 .848L1.024 15.51a.6.6 0 01-.848-.848L6.836 8 .176 1.34a.6.6 0 010-.85z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.176.49a.6.6 0 01.848 0L8.11 7.577a.6.6 0 010 .848L1.024 15.51a.6.6 0 01-.848-.848L6.836 8 .176 1.34a.6.6 0 010-.85z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#arrow-right_svg__a)"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxtYXNrIGlkPSJwYXRoLTEtaW5zaWRlLTFfNDE3NDdfNTEwMDEiIGZpbGw9IndoaXRlIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjE3NTczNiAwLjQ5MDY3OEMwLjQxMDA1MSAwLjI1NjM2MyAwLjc4OTk1IDAuMjU2MzYzIDEuMDI0MjYgMC40OTA2NzdMOC4xMDkyMSA3LjU3NTYyQzguMzQzNTIgNy44MDk5NCA4LjM0MzUyIDguMTg5ODMgOC4xMDkyMSA4LjQyNDE1TDEuMDI0MjYgMTUuNTA5MUMwLjc4OTk1IDE1Ljc0MzQgMC40MTAwNTEgMTUuNzQzNCAwLjE3NTczNiAxNS41MDkxQy0wLjA1ODU3ODcgMTUuMjc0OCAtMC4wNTg1Nzg3IDE0Ljg5NDkgMC4xNzU3MzYgMTQuNjYwNkw2LjgzNjQxIDcuOTk5ODlMMC4xNzU3MzYgMS4zMzkyMUMtMC4wNTg1Nzg3IDEuMTA0ODkgLTAuMDU4NTc4NyAwLjcyNDk5MiAwLjE3NTczNiAwLjQ5MDY3OFoiLz4KPC9tYXNrPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMTc1NzM2IDAuNDkwNjc4QzAuNDEwMDUxIDAuMjU2MzYzIDAuNzg5OTUgMC4yNTYzNjMgMS4wMjQyNiAwLjQ5MDY3N0w4LjEwOTIxIDcuNTc1NjJDOC4zNDM1MiA3LjgwOTk0IDguMzQzNTIgOC4xODk4MyA4LjEwOTIxIDguNDI0MTVMMS4wMjQyNiAxNS41MDkxQzAuNzg5OTUgMTUuNzQzNCAwLjQxMDA1MSAxNS43NDM0IDAuMTc1NzM2IDE1LjUwOTFDLTAuMDU4NTc4NyAxNS4yNzQ4IC0wLjA1ODU3ODcgMTQuODk0OSAwLjE3NTczNiAxNC42NjA2TDYuODM2NDEgNy45OTk4OUwwLjE3NTczNiAxLjMzOTIxQy0wLjA1ODU3ODcgMS4xMDQ4OSAtMC4wNTg1Nzg3IDAuNzI0OTkyIDAuMTc1NzM2IDAuNDkwNjc4WiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMi40IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIG1hc2s9InVybCgjcGF0aC0xLWluc2lkZS0xXzQxNzQ3XzUxMDAxKSIvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };